import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'

import { SharedUiDisabilitySelectModule } from '../lib/shared-ui-disability-select.module'
import { DisabilitySelectDocsComponent } from './disability-select-docs/disability-select-docs.component'
import { DisabilitySelectExampleComponent } from './disability-select-docs/disability-select-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiDisabilitySelectModule
  ],
  declarations: [
    DisabilitySelectDocsComponent,
    DisabilitySelectExampleComponent
  ],
  exports: [
    DisabilitySelectDocsComponent
  ]
})
export class SharedUiDisabilitySelectDocsModule {}
